import { Typography, TypographyProps } from '@mui/material';

export function MCTypography(props: TypographyProps) {
    const { children, variant } = props;

    return (
        <Typography
            variant="myCustomersBody"
            component={variant && variant.startsWith('h') ? variant : 'p'}
            {...props}
        >
            {children}
        </Typography>
    );
}
